//import Libraries
import React from 'react';

//import Components

//import Style classes
import "./ImageContent.css";

const imageContent = (props) => {
    const style = { };
    if(props.data.height) style.height = props.data.height;
    let classes = [
        "WorkContent",
        "ImageContent",
        props.data.size === 3 ? "third" 
        : props.data.size === 2 ? "half" 
        : props.data.size === 1 ? "full" : "",
    ]

    const imgElement = (
        <img 
            src={require("../../assets/works/" + props.link + "/" + props.data.path)} 
            alt="" 
        />
    );

    const isExternalLink = (url) => {
        return url.startsWith("http://") || url.startsWith("https://");
    };
    
    const getValidUrl = (url) => {
        if (isExternalLink(url)) return url;
        return "https://" + url;
    };
    
    return (
        <div className={classes.join(" ")} style={style}>
            {props.data.link 
                ? <a href={getValidUrl(props.data.link)} target="_blank" rel="noopener noreferrer">{imgElement}</a>
                : imgElement}
        </div>
    );
}

export default imageContent;
